import { AxiosError } from 'axios';

const ERROR_RETRY_COUNT = 3;

export type RocketErrorDetails = {
  queryErrorPrefix?: string;
  responseErrorMessage?: string;
};

export class RocketError extends Error {
  details?: RocketErrorDetails;

  constructor(message: string, details?: RocketErrorDetails) {
    super(message);
    Object.setPrototypeOf(this, RocketError.prototype);
    this.name = 'RocketError';
    this.details = details;
  }
}

export type MapAxiosErrorToRocketError = (
  error: AxiosError,
  type: 'mutation' | 'query',
  meta?: Record<string, unknown>
) => RocketError | null;

export const getAxiosErrorResponseMessage = (error: unknown): string | undefined => {
  if (!(error instanceof AxiosError)) {
    return undefined;
  }

  const responseData = error.response?.data as { messages?: unknown };
  const firstMessage = Array.isArray(responseData?.messages) ? responseData.messages[0] : undefined;

  return typeof firstMessage === 'string' && firstMessage ? firstMessage : undefined;
};

export const buildRocketErrorMessage = (
  details: RocketErrorDetails | undefined,
  fallback: string
): string => {
  const { queryErrorPrefix, responseErrorMessage } = details || {};
  return [queryErrorPrefix, responseErrorMessage].filter(Boolean).join(': ') || fallback;
};

export const shouldRetryQueryOnError = (failureCount: number, error: unknown): boolean => {
  if (error instanceof AxiosError) {
    const status = error.response?.status;
    // Do not retry on any 4xx client errors, do not retry on 502 errors
    if (status && ((status >= 400 && status < 500) || status === 502)) {
      return false;
    }
  }
  return failureCount < ERROR_RETRY_COUNT;
};
